import { http } from "../../core/utils/http";
import authHeader from "../../core/utils/auth.header.js";
import axios, { Axios } from "axios";
import { Create, Update, UpdateSettings } from "./interface/payroll.interface";
import authhHeader from "../../core/utils/authh.header";

class Payroll {
  constructor(private readonly request: Axios) {}

  private createAxiosInstance() {
    return axios.create({
      baseURL: import.meta.env.VITE_SECOND_BASE_URL, 
      headers: authhHeader(), 
    });
  }

  async get(organisationId: number, scheduledDate: string | null, status: string | null,  omitStatus: string | null, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get('/Payroll/get-organisation-payroll', {
        headers: authhHeader(),
        params: {
          OrganisationId: organisationId,
          ScheduledDate: scheduledDate,
          Status: status,
          OmitStatus: omitStatus,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getRecurring(organisationId: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
    .get('/Payroll/recurring', {
      headers: authhHeader(),
      params: {
        OrganisationId: organisationId,
        PageSize: pageSize,
        PageNumber: pageNumber,
      },
    })
    .then((res) => res)
    .catch((err) => {
         console.error("Error fetchin recurring payroll:", err.response ? err.response.data : err.message);
        throw err;
      });
}

 
  async initiate(organisationId: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get('/Payroll/get-payroll', {
        headers: authhHeader(),
        params: {
          OrganisationId: organisationId, 
          PageSize: pageSize,
          PageNumber: pageNumber
        }
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getPayrollHistory(userId: number, transactionMonth?: number, transactionYear?: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest      
    .get('/Transaction/get-user-transactions', {
        headers: authhHeader(),
        params: {
            UserId: userId,
            TransactionMonth: transactionMonth,
            TransactionYear: transactionYear,
            PageSize: pageSize,
            PageNumber: pageNumber
        }
    })
    .then((res) => {
        return res;
    })
    .catch((err) => {
        return err;
    });
  }
  async generatePayslip(employeeId: number, organisationId: number, startDate: string, endDate: string): Promise<any> {
    const customRequest = this.createAxiosInstance();
    
    const requestBody = {
        employeeId,
        organisationId,
        startDate,
        endDate
    };
    console.log("Request Body for Payslip Generation:", requestBody);

    return await customRequest
        .post('/Payslip/generate', requestBody, {
            headers: authhHeader(),
        })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error("Error generating payroll:", err.response ? err.response.data : err.message);
            return err;
        });
}

async getSalaryBreakdown(employeeId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  return await customRequest
      .get(`/Salary/salary-breakdown/${employeeId}`, {
          headers: authHeader(),
      })
      .then((res) => {
          return res;
      })
      .catch((err) => {
          return err;
      });
}


  async getEmployeePayroll(organisationId: number, employeeId: number, pageSize: number = 10, pageNumber: number = 1): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .get('/Payroll/get-employee-payroll', {
        headers: authhHeader(),
        params: {
          OrganisationId: organisationId,
          EmployeeId: employeeId,
          PageSize: pageSize,
          PageNumber: pageNumber,
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  
  async createPayroll(payload: {
    organisationId: number;
    employeesSalary: Array<{
      employeeId: number;
      grossPay: number;
      bonusAmount: number;
      bonusReason: string;
      deductionAmount: number;
      deductionReason: string;
      taxAmount: number;
      netPay: number;
    }>;
    scheduledMonth: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .post("/Payroll/create-payroll", payload)
      .then((res) => res)
      .catch((err) => {
        // console.error("Error creating payroll:", err.response?.data);
         console.error("Error creating payroll:", err.response ? err.response.data : err.message);
        throw err;
      });
  }

  async updatePayroll(payload: {
    payrollId: number;
    organisationId: number;
    employeesSalary: Array<{
      lineItemId: number;
      bonusAmount: number;
      bonusReason: string;
      deductionAmount: number;
      deductionReason: string;
      taxAmount: number;
      netPay: number;
    }>;
    paytype: string;
    scheduledMonth: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .put("/Payroll/update-payroll", payload)
      .then((res) => res)
      .catch((err) => {
        console.error("Error updating payroll:", err.response?.data ?? err);
        throw err;
      });
  }

  async setupPayoutTime(payload: {
    organisationId: number;
    payrollId: number;
    sendTime: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .put("/Settings/setup-payout-time", payload)
      .then((res) => res)
      .catch((err) => {
        console.error("Error setting up payout time:", err.response ? err.response.data : err.message);
        throw err;
      });
  }
  
async updatePayrollFrequency(payPeriod: string): Promise<any> {
  const customRequest = this.createAxiosInstance();
  
  return await customRequest
    .put("/Settings/frequency", null, {
      params: { payPeriod }
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error updating payroll frequency:", err.response ? err.response.data : err.message);
      throw err;
    });
}

  
  async getPayroll(params: {
    organisationId: number;
    payrollId: number;
    pageSize?: number;
    pageNumber?: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .get("/Payroll/get-payroll", { params })
      .then((res) => res)
      .catch((err) => {
        console.error("Error fetching payroll:", err.response ? err.response.data : err.message);
        throw err;
      });
  }

async toggleRecurringPayroll(
  payrollId: number,
  isRecurring: boolean
): Promise<any> {
  const customRequest = this.createAxiosInstance();
  
  return await customRequest
    .put(`/Payroll/${payrollId}/toggle-recurring`, null, {
      params: { isRecurring }
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error toggling recurring payroll:", err);
      throw err;
    });
}


  async getPayrollTransaction(params: {
    payrollId: number;
    pageSize?: number;
    pageNumber?: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .get("/Transaction/get-payroll-transaction", { params })
      .then((res) => res)
      .catch((err) => {
        console.error("Error fetching payroll:", err);
        throw err;
      });
  }
  // async approvePayroll(payrollId: number): Promise<any> {
  //   const customRequest = this.createAxiosInstance();
  //   return await customRequest
  //     .post("/Payroll/approve", null, { params: { payrollId } })
  //     .then((res) => res)
  //     .catch((err) => {
  //       const errorMessage = err.response?.data?.message || "An unexpected error occurred. Please try again.";
  //       console.error("Error approving payroll:", errorMessage);
  //       throw new Error(errorMessage); 
  //     });
  // }

  async approvePayroll(payrollId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();
  return await customRequest
    .post("/Payroll/approve", null, { params: { payrollId } })
    .then((res) => res)
    .catch((err) => {
      if (err.response?.status === 403) {
        // Custom message for 403 Forbidden
        const errorMessage = "You are not permitted to approve a payroll. A notification has been sent to the SuperAdmin";
        console.error("Error approving payroll (403):", errorMessage);
        throw new Error(errorMessage);
      }
      const errorMessage = err.response?.data?.message || "An unexpected error occurred. Please try again.";
      console.error("Error approving payroll:", errorMessage);
      throw new Error(errorMessage);
    });
}

  // async declinePayroll(payrollId: number, mainOrganisationUserId: number): Promise<any> {
  //   const customRequest = this.createAxiosInstance();
  //   return await customRequest
  //     .post("/Payroll/reject", { payrollId, mainOrganisationUserId })
  //     .then((res) => res)
  //     .catch((err) => {
  //       console.error("Error declining payroll:", err.response ? err.response.data : err.message);
  //       throw err;
  //     });
  // }

  async declinePayroll(payrollId: number, mainOrganisationUserId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .post("/Payroll/reject", { payrollId, mainOrganisationUserId })
      .then((res) => res)
      // .then((res) => {
      //   if (res.data && res.data.succeeded) {
      //     return res.data;
      //   } else {
      //     throw new Error(res.data.message); 
      //   }
      // })
      .catch((err) => {
        const errorMessage = err.response?.data?.message || "An unexpected error occurred. Please try again.";
        console.error("Error declining payroll:", errorMessage);
        throw new Error(errorMessage); 
      });
  }
  

  // async submitPayroll(payload: { payrollId: number; organisationId: number }): Promise<any> {
  //   const customRequest = this.createAxiosInstance();
  //   return await customRequest
  //   .post(`/Payroll/submit-payroll`, payload)
  //     .then((res) => res)
  //     .catch((err) => {
  //       console.error("Error submitting payroll:", err);
  //       throw err;
  //     });
  // }

  async submitPayroll(payload: { payrollId: number; organisationId: number }): Promise<any> {
    const customRequest = this.createAxiosInstance();
    return await customRequest
      .post(`/Payroll/submit-payroll`, payload)
      .then((res) => res)
      .catch((err) => {
        // Log the full error response
        console.error("Error submitting payroll:", err.response ? err.response.data : err.message);
        throw err; // Re-throw the error if needed
      });
}

  
  async savePayrollToDraft(payload: any): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .post("/Payroll/save-payroll-to-draft", payload)
      .then((res) => res)
      .catch((err) => {
        console.error("Error saving payroll to draft:", err);
        throw err;
      });
  }
  
  async getOrganisationDraftedPayroll(params: {
    organisationId: number;
    draftedPayrollId?: number;
    pageSize?: number;
    pageNumber?: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    try {
      const response = await customRequest.get("/Payroll/get-organisation-drafted-payroll", { params });
      return response.data;
    } catch (err) {
      console.error("Error fetching organisation drafted payroll:", err);
      throw err;
    }
  }
  async deleteDraftedPayroll(draftedPayrollId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  try {
    const response = await customRequest.delete(`/Payroll/delete-drafted-payroll/${draftedPayrollId}`);
    return response.data;
  } catch (err) {
    console.error("Error deleting drafted payroll:", err);
    throw err;
  }
}

async removeEmployeeFromPayroll(payrollId: number, payrollLineItemId: number): Promise<any> {
  const customRequest = this.createAxiosInstance();

  const params: any = {};
  if (payrollLineItemId !== null && payrollLineItemId !== undefined && payrollLineItemId !== 0) {
    params.payrollLineItemId = payrollLineItemId;
  } else {
    throw new Error("payrollLineItemId is required to remove employee");
  }

  console.log("Remove employee request params:", { payrollId, ...params });

  return await customRequest
    .put(`/Payroll/remove-employee-on-payroll/${payrollId}`, null, {
      params,
    })
    .then((res) => res)
    .catch((err) => {
      console.error("Error removing employee from payroll:", err.response?.data || err);
      throw err;
    });
}

  
    // async getPayroll(organisationId: number, payrollId: number): Promise<any> {
    //   const customRequest = this.createAxiosInstance();

    //   return await customRequest
    //     .get(`/Payroll/get-payroll`, {
    //       params: {
    //         OrganisationId: organisationId,
    //         PayrollId: payrollId
    //       }
    //     })
    //     .then((res) => res.data) 
    //     .catch((err) => {
    //       console.error("Error fetching payroll:", err);
    //       throw err;
    //     });
    // }

 // async initiate(department: any): Promise<any> {
  //   return await this.request
  //     .get(`/payroll/init?department=${department}`, {
  //       headers: authHeader(),
  //     })
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((err) => {
  //       return err;
  //     });
  // }

  async preview(department: any): Promise<any> {
    return await this.request
      .get(`/payroll/init?department=${department}&show=preview`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getSingle(id: string): Promise<any> {
    return await this.request
      .get(`/payroll/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async draft(): Promise<any> {
    return await this.request
      .get(`/payroll?status=draft`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async getDraftedPayrollCount(organisationId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .get(`/Payroll/drafted-payroll-count/${organisationId}`, {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async generateCsvTemplate(): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .post('/Payroll/generate-csv-template', null, {
        headers: authhHeader(),
        responseType: 'blob',
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async downloadPayrollCSV(params: {
    organisationId: number;
    payrollId: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get('/Payroll/download-csv', {
        headers: authhHeader(),
        params,
        responseType: 'blob',
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async downloadEmployeePayslip(params: {
    organisationId: number;
    payrollId: number;
    employeeId: string;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get('/Payslip/download-employee-payslip', {
        headers: authhHeader(),
        params,
        responseType: 'blob',
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async downloadAllPayslips(params: {
    organisationId: number;
    payrollId: number;
  }): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get('/Payslip/download-all-payslips', {
        headers: authhHeader(),
        params,
        responseType: 'blob',
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async getInternalPayslipList(payrollId: number): Promise<any> {
    const customRequest = this.createAxiosInstance();

    return await customRequest
      .get(`/Payslip/internal/list/${payrollId}`, {
        headers: authhHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async uploadCsv(formData: FormData): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .put('/Payroll/upload-payroll', formData, {
        headers: {
          ...authhHeader(),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error('Error uploading CSV:', err.response?.data);
        return Promise.reject(err);
      });
  }

  async uploadPayrollCsv(csvFile: File, organisationId: number, scheduledMonth: string): Promise<any> {
    const formData = new FormData();
    formData.append('CsvFile', csvFile);
    
    const params = {
      params: {
        OrganisationId: organisationId,
        ScheduledMonth: scheduledMonth,
      },
    };
  
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .put('/Payroll/upload-payroll', formData, {
        headers: {
          ...authhHeader(),
          'Content-Type': 'multipart/form-data',
        },
        ...params,
      })
      .then((res) => {
        return res.data; 
      })
      .catch((err) => {
        throw err; 
      });
  }
  
  

  async getOrganisationPayrollCount(organisationId: number, status: string | null, omitStatus: string | null = null): Promise<any> {
    const customRequest = this.createAxiosInstance();
  
    return await customRequest
      .get(`/Payroll/organisation-payroll-count/${organisationId}`, {
        headers: authhHeader(),
        params: {
          status: status,
          omitStatus: omitStatus
        },
      })
      .then((res) => res)
      .catch((err) => err);
  }
  
  
  async create(data: Create): Promise<any> {
    return await this.request
      .post(
        "/payroll",
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async update(data: Update, id: string): Promise<any> {
    return await this.request
      .put(
        `/payroll/${id}`,
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async delete(id: string): Promise<any> {
    return await this.request
      .delete(`/payroll/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }

  async settings(): Promise<any> {
    return await this.request
      .get(`/payroll/settings`, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async deleteMany( data: string[]): Promise<any> {
    return await this.request
      .delete(
        `/payroll/${data}`,
      
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async retryPayment(id: string, data: any): Promise<any> {
    return await this.request
      .post(
        `/payroll/${id}/payments`,
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
  async updateSettings(data: UpdateSettings): Promise<any> {
    return await this.request
      .put(
        `/payroll/settings`,
        { ...data },
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  }
}

export default new Payroll(http);
